<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="layout-sidebar-top">
        <a href="/">
            <img src="assets/layout/images/logo-sgmao.jpg" alt="SGMAO"
                class="layout-sidebar-logo" style="height:36px;border-radius:6px" />
            <img src="assets/layout/images/logo-sgmao.jpg" alt="SGMAO"
                class="layout-sidebar-logo-slim" style="height:32px;border-radius:6px" />
        </a>
        <button class="layout-sidebar-anchor p-link" type="button" (click)="anchor()"></button>
    </div>
    <!-- app-menu-profile retire : bloc de demo (faux profil "Amy Elsner /
    Webmaster", liens vers des routes de demo /documentation et /profile/create
    qui n'existent pas dans l'app). -->
    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>